import { Collapse, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";

import Header from "../../components/common/Layouts/Header";
import Footer from "../../components/common/Layouts/Footer";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import faqLeftImage from "../../assets/images/faq-left-img.png";
import "../../assets/styles/components_styles/faqPage.css";

const FAQ_ITEMS = [
  {
    key: "1",
    label: "Is Pingvite free to use?",
    children:
      "Pingvite is free to use for visitors. Organizers can choose from one of our plans and begin hosting their events.",
  },
  {
    key: "2",
    label: "How can I publish my event?",
    children:
      "Pingvite has an easy to use interface for DIY event management. One can fill in basic details for events such as event name, description, address, relevant images and publish an event. Adding further details such as ticket types, RSVP, enrolling your contacts list for custom invites can elevate your visitor experience.",
  },
  {
    key: "3",
    label: "Can I publish online events on Pingvite?",
    children:
      "Yes, you can list, promote and accept reservations for online events.",
  },
  {
    key: "4",
    label: "How can I create tickets for my events?",
    children:
      "Create multiple categories of tickets from the Organizer dashboard. Add pricing tiers as per seating capacity and venue.",
  },
  {
    key: "5",
    label: "Does an Organizer need to sign a contract with Pingvite?",
    children: (
      <>
        No separate contract is required. By creating an event on Pingvite, you
        confirm your acceptance of terms and conditions, privacy policy and
        cancellation policy. If you continue to experience any issues or
        require further clarification, you can connect with our team{" "}
        <a
          href="https://pingvite.in/contact-us.html"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
        .
      </>
    ),
  },
  {
    key: "6",
    label: "How can I process refund requests?",
    children:
      "You can issue a full or partial refund to your attendees. Your attendees will receive respective funds within 10-14 days in their account.",
  },
];

export default function FAQPage() {
  const navigate = useNavigate();

  return (
    <>
      {/* SEO HELMET WRAPPER */}
      <HelmetWrapper
          title="FAQs - Pingvite" 
          description="Read Pingvite's frequently asked questions and answers to help you understand how our platform works." 
          keywords="Pingvite FAQs, frequently asked questions, platform usage, event ticketing, customer support"
      />
      {/* HEADER */}
      <Header isHome={false} />
      {/* CONTENT */}
      <main className="faqPageRoot">
        <section className="faq">
          <div className="container">
            <div className="sectionTitle">
              <div className="headingStart">
                <h2>Find Question &amp; Answers.</h2>
                <p>
                  A Do It Yourself event ticketing platform - Anybody who wants
                  to host an event can create their event very easily. An
                  organizer can host a Free, Paid, or a Virtual event from any
                  location.
                </p>
              </div>
              <div>
                <Button type="primary" size="large" className="btnGradient" onClick={() => navigate("/contact-us")}>View All</Button>
              </div>
            </div>

            <div className="content-grid">
              <div className="qaImageSection">
                <div className="person-image">
                  <img src={faqLeftImage} alt="Person" className="faqImage" />
                </div>
              </div>

              <div className="faq-section">
                <div className="faq-list">
                  <Collapse
                    accordion
                    expandIconPosition="end"
                    items={FAQ_ITEMS}
                    className="faqAccordion"
                    expandIcon={({ isActive }) => (
                      <DownOutlined rotate={isActive ? 180 : 0} />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      {/* FOOTER */}
      <Footer />
    </>
  );
}